/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Ikhpsychologie14Inputs */

const en__field_enum_ikhpsychologie14 = /** @type {(inputs: _Field_Enum_Ikhpsychologie14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`05 - Psychologie und Sportwissenschaften`)
};

const de__field_enum_ikhpsychologie14 = /** @type {(inputs: _Field_Enum_Ikhpsychologie14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`05 - Psychologie und Sportwissenschaften`)
};

/**
* | output |
* | --- |
* | "05 - Psychologie und Sportwissenschaften" |
*
* @param {_Field_Enum_Ikhpsychologie14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_ikhpsychologie14 = /** @type {((inputs?: _Field_Enum_Ikhpsychologie14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Ikhpsychologie14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_ikhpsychologie14(inputs)
	return de__field_enum_ikhpsychologie14(inputs)
});
export { _field_enum_ikhpsychologie14 as "_field_enum_IKHPSYCHOLOGIE" }